
$(document).ready(function(){
  var userLang = $('html').attr("lang");

  /* Sticky Header */
  $(window).scroll(function(){

    var scroll = $(window).scrollTop();
    
    if (scroll > 0){

      $("body").addClass("scroll");
      $(".header-wrapper").addClass("header-sticky");

    } else {

      $("body").removeClass("scroll");
      $(".header-wrapper").removeClass("header-sticky");

    }
    
  });

  // PLACEMENT ICON PANIER HEADER
  $(".footer__column.footer__localization.isolate").insertBefore(".header .link-cart");
  function moveCartIcon() {
    if (!$("body").hasClass("scroll") && !$("body").hasClass("product") && $(window).width() > 1024) {
      $("#cart-icon-bubble").appendTo(".header-wrapper .list-menu--inline");
      $(".footer__column.footer__localization.isolate").insertBefore("#cart-icon-bubble");
    } else if ($("body").hasClass("scroll")) {
      $(".header-wrapper .header__inline-menu").after($("#cart-icon-bubble"));
      $(".footer__column.footer__localization.isolate").insertBefore("#cart-icon-bubble");
    }
  }


  moveCartIcon();

  $(window).resize(function () {
    moveCartIcon();
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        moveCartIcon();
      }
    });
  });

  observer.observe(document.body, { attributes: true });

  /* HOVER HEADER */
  var windowWidth = $(window).width();
  
  if (windowWidth > 1024){

   $(".mega-menu").hover(function(){

    $(this).attr("open", "");

  },function(){

    $(this).removeAttr("open", "");

  });

 }


 var browserURL = window.location.href;

 if (browserURL == "https://copin.fr/collections/collection01"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection01" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/t/7/assets/collection01.jpg?v=1703836849">')
  $(".collection-hero__title").addClass("big collection01");
  $("body").addClass("collection01");

} else if (browserURL == "https://copin.fr/collections/collection00"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection00" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/t/7/assets/collection00.jpg?v=1703836849">')
  $(".collection-hero__title").addClass("big");
  $("body").addClass("collection00");

} else if (browserURL == "https://copin.fr/collections/collection-82"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection-82" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/banner-collection-82.webp?v=1739394925">')
  $(".collection-hero__title").addClass("big");
  $(".collection-hero__description").addClass("descr");
  $("li.grid__item.collection-desc").remove();
  $("body").addClass("withBanner");

} else if (browserURL == "https://copin.fr/collections/collection-rifli"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection-rifli" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/banner-collection-rifli.webp?v=1739394914">')
  $(".collection-hero__title").addClass("big");
  $(".collection-hero__description").addClass("descr");
  $("li.grid__item.collection-desc").remove();
  $("body").addClass("withBanner");

} else if (browserURL == "https://copin.fr/collections/collection-dune"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection-dune" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/banner-collection-dune.webp?v=1739394922">')
  $(".collection-hero__title").addClass("big");
  $(".collection-hero__description").addClass("descr");
  $("li.grid__item.collection-desc").remove();
  $("body").addClass("withBanner");

} else if (browserURL == "https://copin.fr/collections/collection-daisy"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection-daisy" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/banner-collection-daisy.webp?v=1739394923">')
  $(".collection-hero__title").addClass("big");
  $(".collection-hero__description").addClass("descr");
  $("li.grid__item.collection-desc").remove();
  $("body").addClass("withBanner");

} else if (browserURL == "https://copin.fr/collections/collection-festonee"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection-festonee" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/banner-collection-festonne.webp?v=1739394922">')
  $(".collection-hero__title").addClass("big");
  $(".collection-hero__description").addClass("descr");
  $("li.grid__item.collection-desc").remove();
  $("body").addClass("withBanner");

} else if (browserURL == "https://copin.fr/collections/collection-hera"){

  $(".collection-hero__text-wrapper").prepend('<img class="collectionPix" alt="collection-hera" src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/banner-collection-hera.webp?v=1739394924">')
  $(".collection-hero__title").addClass("big");
  $(".collection-hero__description").addClass("descr");
  $("li.grid__item.collection-desc").remove();
  $("body").addClass("withBanner");

}

/* Remplacement Photo HD pour la banner HP */
if ($("body").hasClass("index")){

  $("body.index .banner__content").addClass("pointer");
  $("#shopify-section-template--24360738029913__e3b365ac-5112-4f42-ae90-51088301c2e3 img").addClass("pointer");
  $("#shopify-section-template--24360738029913__e3b365ac-5112-4f42-ae90-51088301c2e3 .image-with-text__heading").addClass("pointer");


  if ( userLang == "fr" ){

    $("#shopify-section-template--24360738029913__1657544929bee2f3d4").click(function(){
      window.location.href = "https://copin.fr/collections/collection-82";
    });
    $("#shopify-section-template--24360738029913__e3b365ac-5112-4f42-ae90-51088301c2e3 img").click(function(){
      window.location.href = "https://copin.fr/pages/histoire";
    });
    $("#shopify-section-template--24360738029913__e3b365ac-5112-4f42-ae90-51088301c2e3 .image-with-text__heading").click(function(){
      window.location.href = "https://copin.fr/pages/histoire";
    });
  }

  if ( userLang == "en" ){

    $("#shopify-section-template--24360738029913__1657544929bee2f3d4").click(function(){
      window.location.href = "https://copin.fr/en/collections/collection-82";
    });
    $("#shopify-section-template--24360738029913__e3b365ac-5112-4f42-ae90-51088301c2e3 img").click(function(){
      window.location.href = "https://copin.fr/en/pages/histoire";
    });
    $("#shopify-section-template--24360738029913__e3b365ac-5112-4f42-ae90-51088301c2e3 .image-with-text__heading").click(function(){
      window.location.href = "https://copin.fr/en/pages/histoire";
    });

  }

}

/* sélecteur de taille PAGE PRODUIT */
$("body.product .product-form__input .select select[name='options[Taille]']").prepend('<option value="">SÉLECTIONNER LA TAILLE</option>');

/* Ajustements nouvelle page produit */
if ($(window).width()> 749){

  /* Ajustement lien instagram */
  $("a[href='https://www.instagram.com/copin/'").attr("target","_blank");

}

if ($(window).width()< 750){

  if ($("body.product").length){

    $("body.product .product--thumbnail_slider .thumbnail-slider").insertBefore("body.product .product__info-wrapper .retour-link");

  }

}

/* Hackmail footer */
$(".hackmail").attr("href","mailto:bonjour@copin.fr").html("bonjour@copin.fr");

/* SELECTEUR LANG */
$('#FooterLanguageForm .disclosure__button').html("FR");
$('ul#FooterLanguageList li:nth-child(1) a').html("FR");
$('ul#FooterLanguageList li:nth-child(2) a').html("EN");

/* Trackin Pinterest pour la Prise de RDV : formulaire de contact */
if ($("#ContactForm").length && $("h2.form-status").length){ pintrk("track","lead",{lead_type:"RDV"}); console.log("Tracking Pinterest"); }

/* produits de la catégorie "fiancailles" */
if ($('body').hasClass('product') && $('body').hasClass('bagues-fiancailles')) {

  $('.price-item--regular').each(function() {
    let currentText = $(this).text().trim();
    if (!currentText.startsWith('À partir de')) {
      let formattedPrice = currentText.replace('€', '').replace('.', ' ').replace('TTC', '').trim();
      $(this).html('<span>À PARTIR DE</span>' + formattedPrice + ' € TTC');
      if ( userLang == "en" ){ $(this).html('<span>FROM</span>' + formattedPrice + ' € <span class="vat">VAT INCL.</span>');}
    }
  });

  if ( userLang == "fr" ){$(".product-form__buttons").prepend('<a class="btnContact" href="https://copin.fr/pages/contact">contactez-nous</a>');}
  if ( userLang == "en" ){$(".product-form__buttons").prepend('<a class="btnContact" href="https://copin.fr/en/pages/contact">contact us</a>');}

}

  /* ----------------------------------------------------------------
  Traductions Js qlqs mots du site COPIN (pas besoin de referencement)
  ---------------------------------------------------------------- */

  if ( userLang == "en" ) {

    /* LANG */
    $('#FooterLanguageForm .disclosure__button').html("EN");

    /* FOOTER */
    $('ul.footer__navigation__sublist li:nth-child(3) a').html("Contact us via whatsapp");
    $('ul.footer__navigation__sublist li:nth-child(5)').html("OPEN FROM MONDAY TO SATURDAY");
    $('ul.footer__navigation__list li:nth-child(3) p').html("INFORMATION");
    $('ul.footer__navigation__list li:nth-child(4) p').html("FOLLOW US");

    /* FICHE PRODUIT */
    $('body.product .product__info-wrapper .retour-link').html("< back");
    $('body.product .accordion details#Details-a8379f12-f0f5-4c14-b2bd-46a6e862953b-template--24360738488665__main h2').html("Details");
    $('body.product .accordion details#Details-768877b5-8359-4127-9a6d-7fb75668000e-template--24360738488665__main h2').html("Caring for your jewelry");
    $('body.product .accordion details#Details-15adac61-968c-4743-a1f9-2ab9e76d5148-template--24360738488665__main h2').html("Delivery");
    $('body.product .accordion details#Details-4623c086-4403-40ed-a492-9481b31a46c8-template--24360738488665__main h2').html("Size guide");
    $('body.product .collection__title.title-wrapper h2').html("DISCOVER THE OTHER UNIQUE PIECES");
    var delivery = '<p>Delivery is free in France and the European Union and takes 3 to 5 days. </p><p>For delivery outside the European Union, also allow 3 to 5 days. </p><p>According to our Conditions of Sale policy, you have 14 days (from receipt of your order) for us to issue a refund or exchange. </p><p>Our products must be returned in new and undamaged condition, with all protective materials in place, as well as the original box and packaging. </p><p>Failure to comply with these Conditions of Sale will give us the right to refuse the returned product and send it back to you, at your expense. </p>'
    $('body.product details#Details-15adac61-968c-4743-a1f9-2ab9e76d5148-template--24360738488665__main .accordion__content').html(delivery);

    /* CART */
    $('body.product #cart-notification .cart-notification__links button.button').html("Proceed to payment");
    var taxNoteCart = 'Taxes included. <a href="/en/policies/shipping-policy">Shipping</a> costs are calculated at checkout.'
    $('body.cart .tax-note.caption-large').html(taxNoteCart);
    $('body.cart button#checkout').html("Proceed to payment");

    /* Redirection vers la page EN  (Je l'ai fait en js Provisoirement) */
    $("ul.footer__navigation__list li:nth-child(4) ul li:nth-child(2) a").attr("href","https://copin.fr/en/#shopify-section-template--21792100450649__5cd12a4b-5b9b-44a6-bf49-e52572300780");

  }

  /* FERMETURE CONTENU ACCORDION */
  $("body.product .product__accordion .accordion__content").prepend('<span class="closeAccordion"></span>');
  $(".closeAccordion").click(function(){$("details").removeAttr("open", "");$("body.product .product__accordion .accordion__content").addClass("animClose");});

  /* FIN TRADUCTION */

  /* PAGE CONTACT */
  if ($(window).width()< 1309){
    $('#boutique .map img:not(.onlyMob)').attr('src','https://cdn.shopify.com/s/files/1/0613/6509/2512/files/mapsCopinTab.png?v=1720771148')
  }
  if ($(window).width()> 600){
    $("#breadcrumbs").prependTo("#ContactForm.pageContact .form-header");
  }

  /* Génération du slider AVIS */
  if ($("body").hasClass("product") || $("#ContactForm").length){

    $("#AvisGoogle").show();

    var sliderContent = "";

    $("#AvisGoogle ul").each(function(){

      var slideAvis1 = $("li:nth-child(1)",this).html();
      var slideAvis2 = $("li:nth-child(2)",this).html();
      var slideAvis3 = $("li:nth-child(3)",this).html();
      var slideAvis4 = $("li:nth-child(4)",this).html();
      var slideAvis5 = $("li:nth-child(5)",this).html();

      sliderContent += '<div class="swiper sliderAvis"> <ul class="swiper-wrapper"> <li class="swiper-slide">'+slideAvis1+'</li> <li class="swiper-slide">'+slideAvis2+'</li> <li class="swiper-slide">'+slideAvis3+'</li> <li class="swiper-slide">'+slideAvis4+'</li> <li class="swiper-slide">'+slideAvis5+'</li> </ul> <div class="swiper-pagination"></div> </div>';

    });

    $("#AvisGoogle ul").html(sliderContent);

  }

  /* Slider AVIS GOOGLE */
  var swiper = new Swiper(".sliderAvis",{
    direction:'horizontal',autoplay:{delay:5000},
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView:1,
    loop:true,
    effect:'slide'

  });
  
  /* REDIRECTION AVIS GOOGLE */
  $("#AvisGoogle .wrap_avis .wrap_slider").click(function(){
    window.open('https://www.google.fr/search?source=hp&ei=IPWJXI6yNsLHwALm2KioBw&q=copin+paris&btnK=Recherche+Google&oq=mkt+shop&gs_l=psy-ab.3...7080.7633..9815...0.0..0.0.0.......0....1..gws-wiz.....0.#btnK=Recherche%20Google&lrd=0x47e66e25981107ff:0xde03dbd8a35989ff,1,,,,', '_blank');
  });

  /* Enlever la barre de contrôle dans les videos : page produit */
  if ($("body").hasClass("product")){

    $("body.product media-gallery").contentChanged(function(){
      if ($(window).width() > 1024){
        $("media-gallery video").removeAttr("controls").attr("loop","loop");
      }
    });
    $("body.product .product-media-modal__content").contentChanged(function(){
      $(".product-media-modal__content video").removeAttr("controls").attr("loop","loop");
    });
    
  }

  // homepage > Slider product : Si 2e image existe, l'hover est appliqué
  $("#shopify-section-template--24360738029913__05796050-67c7-4058-80a1-089f25956036 .slider--desktop.grid--4-col-desktop .grid__item,#shopify-section-template--24360738029913__featured_collection_nUY7Ni .slider--desktop.grid--4-col-desktop .grid__item,#shopify-section-template--24360738226521__featured_collection_dUpK8F .slider--desktop.grid--4-col-desktop .grid__item,body.product .grid.product-grid .grid__item,#product-grid .grid__item").hover(
    function () {
      if ($(this).find("img.motion-reduce").length > 0) {
        $(this).find("img.motion-reduce").css("display", "block");
        $(this).find(".link-img-collection img,.videoGridWrap").css("display", "none");
      }
      $(this).find(".btn-cta").css("opacity", "1");
    },
    function () {
      if ($(this).find("img.motion-reduce").length > 0) {
        $(this).find("img.motion-reduce").css("display", "none");
        $(this).find(".link-img-collection img,.videoGridWrap").css("display", "block");
      }
      $(this).find(".btn-cta").css("opacity", "0");
    }
    );

  // Ajout d’un CTA et Descr sur la catégorie Fiançailles
  if ( userLang == "fr" ){
    const newListItem = `
    <li class="grid__item fiancailles_ collection-desc slider__slide">
    <h2>FIANÇAILLES</h2>
    <p>Les bagues de fiançailles de Copin allient modernité et élégance pour célébrer votre heureux événement.</p>
    <a href="/collections/bagues-fiancailles" class="button button--secondary">COMMANDER</a>
    </li>
    `;
    $("#shopify-section-template--24360738029913__featured_collection_nUY7Ni .collection .product-grid").prepend(newListItem);
  }
  if ( userLang == "en" ){
    const newListItem = `
    <li class="grid__item fiancailles_ collection-desc slider__slide">
    <h2>ENGAGEMENT</h2>
    <p>Copin's engagement rings combine modernity and elegance to celebrate your happy event.</p>
    <a href="/en/collections/bagues-fiancailles" class="button button--secondary">ORDER</a>
    </li>
    `;
    $("#shopify-section-template--24360738029913__featured_collection_nUY7Ni .collection .product-grid").prepend(newListItem);
  }

  // REPLACE BOUTON CLASS
  if ($("body").hasClass("index")){
    $('.image-with-text .button.button--primary').removeClass('button--primary').addClass('button--secondary');
    $('.multicolumn-card__info .link').removeClass('link animate-arrow').addClass('button button--secondary');
  }

  // Ajout d'un CTA dans chaque produit de la collection
  if (windowWidth > 1024){
   $('.collection li.grid__item .card__content').each(function() {
    var productLink = $(this).find('.card__information a').attr('href');
    if (productLink) {
      var ctaButton = $('<a>', {
        href: productLink,
        class: 'btn-cta button button--primaire',
        text: 'DÉCOUVRIR'
      });
      $(this).append(ctaButton);
    }
  });
 }

 if (userLang == "en") {
  $('.collection li.grid__item .btn-cta').text("DISCOVER");
}

// Ajout image decoration dans la grille collection
var decoImgRifli = `<li class="grid__item decoImg_"> 
<img src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/img-deco-rifli.webp?v=1739396839">
</li>`;
var decoImg82 = `<li class="grid__item decoImg_"> 
<img src="https://copin.fr/cdn/shop/files/bague-82-or-jaune-diamants-176569.jpg?v=1711724995">
</li>`;
var decoImgDUNE = `<li class="grid__item decoImg_"> 
<img src="https://cdn.shopify.com/s/files/1/0613/6509/2512/files/img-deco-dune.webp?v=1739396837">
</li>`;
var decoImgFestonee = `<li class="grid__item decoImg_"> 
<img src="https://copin.fr/cdn/shop/files/alliance-festonnee-en-or-jaune-saphirs-bleus-et-grenats-tsavorites-488387.jpg?v=1711724997">
</li>`;
var decoImgHera = `<li class="grid__item decoImg_"> 
<img src="https://copin.fr/cdn/shop/files/bague-hera-s-en-or-blanc-et-emeraudes-164791.jpg?v=1711725074">
</li>`;
$("body.collection-rifli #product-grid").append(decoImgRifli);
//$("body.collection-82 #product-grid").append(decoImg82);
$("body.collection-dune #product-grid").append(decoImgDUNE);
$("body.collection-festonee #product-grid").append(decoImgFestonee);
$("body.collection-hera #product-grid").append(decoImgHera);

// MODIF DESIGN PAGE PRODUIT
if ($("body").hasClass("product")){

  if ($(window).width()> 749){
    $("#breadcrumbs").prependTo(".product__title");
  }

  let priceContainer = $(".price--large").closest("div[id]");
  let productTitle = $("div.product__title");

  if (priceContainer.length && productTitle.length) {
    priceContainer.insertAfter(productTitle);
  }

  // Ajout CTA RDV
  if ( userLang == "fr" ){$('<a href="https://copin.fr/pages/contact" class="btn-rdv">DÉCOUVRIR LA PIÈCE À L\'APPARTEMENT</a>').insertAfter('.product-form.product-form form');}
  if ( userLang == "en" ){$('<a href="https://copin.fr/en/pages/contact" class="btn-rdv">DISCOVER THE PIECE AT THE APARTMENT</a>').insertAfter('.product-form.product-form form');}

// TAILLE PRODUIT
$(".product-form__input .select").each(function () {
  var select = $(this).find("select[name='options[Taille]']");
  
  if (select.length) {
    $(this).css("display", "none");
    $(this).after(`
      <div class="custom-size-selector">
      <span class="prev-size">&lt;</span>
      <div class="size-options">
      </div>
      <span class="next-size">&gt;</span>
      </div>
      `);

    var sizeContainer = $(this).next(".custom-size-selector").find(".size-options");

    select.find("option").each(function() {
      var size = $(this).val();
      if (size) {
        var sizeDiv = $("<div>").text(size).addClass("size-option").attr("data-size", size);
        sizeContainer.append(sizeDiv);
      }
    });

    var defaultSize = select.val();
    $(".size-option[data-size='" + defaultSize + "']").addClass("active");

    $(".size-option").click(function() {
      $(".size-option").removeClass("active");
      $(this).addClass("active");
      var newSize = $(this).data("size");
      select.val(newSize).trigger("change");
      select[0].dispatchEvent(new Event('change', { bubbles: true }));
    });

    $(".prev-size").click(function() {
      sizeContainer.animate({ scrollLeft: "-=50" }, 200);
    });

    $(".next-size").click(function() {
      sizeContainer.animate({ scrollLeft: "+=50" }, 200);
    });
  }

  $("select[name='options[Couleur]']").closest(".product-form__input").find("label").remove().end().find(".select").css("margin-bottom", "15px");

  /* Positionnement de l'icône */
  function adjustIconPosition() {
    var selectedOption = $(".select__select option:selected").text().trim();
    var tempSpan = $("<span>").text(selectedOption).css({
      "visibility": "hidden",
      "white-space": "nowrap",
      "font-size": $(".select__select").css("font-size"),
      "font-family": $(".select__select").css("font-family"),
      "position": "absolute"
    });

    $("body").append(tempSpan);
    var textWidth = tempSpan.width();
    tempSpan.remove();

    var paddingRight = 20;
    var selectWidth = $(".select__select").width();
    var newRight = selectWidth - textWidth - paddingRight;

    $(".icon-caret").css("right", newRight + "px");
  }

  adjustIconPosition();

  $(".select__select").on("change", function () {
    adjustIconPosition();
  });

});

}


  // FOOTER NEWSLETTER 
  if ($(".footer__navigation__list .newsletter-form").length === 0) {
    $.get("/", function (data) {
      const titleNewsForm = "<p>NEWSLETTER</p>";
      const newsletterForm = $(data).find(".newsletter-form").clone();
      if (newsletterForm.length) {       
        $(".footer__navigation__list > li:first-child").prepend(newsletterForm);
        $(".footer__navigation__list > li:first-child").prepend(titleNewsForm);
        if ( userLang == "fr" ){$('.newsletter-form__button').append('<span>S\'ABONNER</span>');}
        if ( userLang == "en" ){$('.newsletter-form__button').append('<span>SUBSCRIBE</span>');}
      }
    });

    // FOOTER MOBILE
    $("#footer .navName").click(function(){
      $(this).toggleClass("open");
      $(this).next("ul").slideToggle();
    });

  }

  $(window).on("scroll", function () {
    let footerLogo = $('#footer .logoCCC');
    let footerOffset = footerLogo.offset().top;
    let windowBottom = $(window).scrollTop() + $(window).height();
    let headerLogo = $('.header-wrapper.header-sticky .header__heading-logo');

    if (windowBottom > footerOffset) {
      headerLogo.css('opacity', '0');
    } else {
      headerLogo.css('opacity', '1');
    }
  });

  /* remove srcset width height pour avoir une bonne qualité d'image */
  $("img").not(".motion-reduce, .link-img-collection img").each(function() {
    let src = $(this).attr("src");
    if (src) {
      src = src.replace(/&width=\d+/, "");
      $(this).attr("src", src);
    }
    $(this).removeAttr("srcset width height");
  });

  // CHANGE Url pour mobile
  function updateImageSrc() {
    if ($(window).width() < 601) {
      $('#shopify-section-template--24360738029913__multicolumn_w77gfE .multicolumn-list__item.center .media--adapt img')
      .attr('src', 'https://cdn.shopify.com/s/files/1/0613/6509/2512/files/decouvrir-nouveautes-mob.webp?v=1741680924');
    }
  }

  updateImageSrc();
  $(window).resize(updateImageSrc);
  
});

$.fn.contentChanged=function(callback){

  var element = this[0];
  var observer = new MutationObserver(function(mutations){
    mutations.forEach(function(mutation){
      if (mutation.type === "childList" || mutation.type === "subtree" || mutation.type === "characterData"){ callback(); } }); });
  observer.observe(element,{childList:true,subtree:true,characterData:true});
  return this;
  
};